import memoizeOne from 'memoize-one';

import {
  DspLegacyStatus,
  TechnicalProviderLegacyStatus,
  Territory,
} from 'interfaces/generated.types';
import { generateMaxImpressionsPerBid } from 'utils/generators';

export interface IDspFormValues {
  altId?: number;
  dailyCap: string;
  maxAds: number;
  id: string;
  name: string;
  journey: string;
  status?: DspLegacyStatus;
  technicalProviderName: string;
  technicalProviderId: string;
  technicalProviderTerritories: { value: Territory; label: string }[];
  territories: { value: Territory; label: string }[];
}

export const dspStatusValues = [
  {
    value: DspLegacyStatus.Draft,
    label: 'Draft',
    isDisabled: (value: DspLegacyStatus) =>
      [DspLegacyStatus.Active, DspLegacyStatus.Inactive].includes(value),
  },
  {
    value: DspLegacyStatus.Active,
    label: 'Active',
    isDisabled: (value: DspLegacyStatus) => [DspLegacyStatus.Draft].includes(value),
  },
  {
    value: DspLegacyStatus.Inactive,
    label: 'Inactive',
    isDisabled: (value: DspLegacyStatus) => [DspLegacyStatus.Draft].includes(value),
  },
];

export const getDspStatusData = memoizeOne(
  (
    values: IDspFormValues,
    technicalProviderStatus: TechnicalProviderLegacyStatus
  ) => [
    {
      status: DspLegacyStatus.Draft,
      required: [
        ...(!values.name ? ["Complete 'Name'"] : []),
        ...(!values.technicalProviderName
          ? ['Complete Parent Programmatic Connector']
          : []),
      ],
    },
    {
      status:
        values.status === DspLegacyStatus.Inactive
          ? DspLegacyStatus.Inactive
          : DspLegacyStatus.Active,
      required: [
        ...(!values.name ? ['Waiting for Name'] : []),
        ...(technicalProviderStatus !== TechnicalProviderLegacyStatus.Active
          ? ['Waiting for Parent Programmatic Connector to be in ACTIVE state']
          : []),
      ],
    },
  ]
);

export const dspDetailsFields = ['name', 'dailyCap'];

export const maxImpressionsPerBid = [...generateMaxImpressionsPerBid()];
